import React, { useEffect, useState } from "react";
import axiosConfig from "../import/axiosConfig";

const ExpenseTable = () => {
  const [expenses, setExpenses] = useState([]);
  const [database, setDatabase] = useState(""); // FIX 1: database state

  const fetchExpenses = async () => {
    const userData = JSON.parse(localStorage.getItem("userData")) || {};
    const db = userData?.database; // FIX 2: local variable
    setDatabase(db); // update state

    try {
      const res = await axiosConfig.get(`/receipt/expenses/${db}`); // FIX 3: correct URL
      setExpenses(res.data?.expenses || []);
    } catch (err) {
      console.log("Error:", err);
    }
  };

  useEffect(() => {
    fetchExpenses();
  }, []); // FIX 4: remove database dependency
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  return (
    <div style={{ padding: "20px" }}>
      <h3>Expenses List</h3>

      <table
        border="1"
        cellPadding="10"
        cellSpacing="0"
        width="100%"
        style={{ marginTop: "20px" }}
      >
        {/* <thead style={{ background: "#f47f18ff" }}> */}
        <thead style={{ background: "#e06c00", color: "black" }}>
          <tr>
            <th>Date</th>
            <th>Particular</th>
            <th>Payment Mode</th>
            <th>Amount</th>
            <th>Remark</th>
          </tr>
        </thead>

        <tbody>
          {expenses.length > 0 ? (
            expenses.map((item, index) => (
              <tr key={index}>
                <td>{formatDate(item.date)}</td>
                <td>{item?.userId?.firstName}</td>
                <td>{item.paymentMode}</td>
                <td>{item.amount}</td>
                <td>{item.remark}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" style={{ textAlign: "center" }}>
                No data found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ExpenseTable;
